import PropTypes from 'prop-types';
import { useContentEmbed } from '../hooks/useContentEmbed';
import { getHostOrigin, extractURLQueryParams } from '../utils/helpers';
/**
 * This is the main app component that extracts the necessary props
 * ({ id, hostOrigin, hostWindow }) and calls the useContentEmbed custom hook
 */
function Application(props) {
  const {
    location: {
      search
    }
  } = props;
  const {
    id,
    inpage,
    origin = '',
    includeHeadElements = false,
    shouldReplaceAllHTML = false
  } = extractURLQueryParams(search);
  const hostOrigin = getHostOrigin(origin);
  const hostWindow = inpage ? window.parent : window.top;
  useContentEmbed(hostOrigin, hostWindow, id, {
    includeHeadElements,
    shouldReplaceAllHTML
  });
  return null;
}
Application.propTypes = {
  location: PropTypes.object
};
export default Application;